import { Component } from '@angular/core'
import { DefaultRowComponent } from '../default-row/default-row.component'
import { CustomTableService } from '../../service/custom-table.service'
import { ICustomTableColumnButton } from '../../modals/interface/custom-table.interface'

@Component({
    selector: 'app-credit-claims-history-row',
    templateUrl: './credit-claims-history-row.component.html',
    styleUrls: ['./credit-claims-history-row.component.scss'],
    standalone: false
})
export class CreditClaimsHistoryRowComponent extends DefaultRowComponent {
  constructor(private customTableService: CustomTableService) {
    super()
  }

  public showCreditNote(btn: ICustomTableColumnButton): boolean {
    if (btn.key == 'downloadCreditNote') {
      const id = this.row[this.uid]
      const data = this.customTableService.dataSource[id]
      return !!data.endCustomerNo
    }
    return true
  }

  public onClick(control: any): void {
    this.customTableService.clicked(control, this.row)
  }
}
